export default "__VITE_ASSET__8883ad1f__"